import CONSTANTS from '../constants'
export type TagsDetails = {
	details: Record<any, any>
	status: 'PENDING_APPROVAL' | 'APPROVED' | 'REJECTED'
}
export type TagsApproval = {
	name: string
	status: number | null
	approverID: string
	lastUpdated: string
	// Set only by GCP application onboarding. Entries carrying this belong to a single
	// application on a shared GCP Project tag record; entries without it are project level.
	application?: string
}
export type TagsRequest = TagsDetails & {
	action: 'CREATE'
	requestorID: string
	approvalStatus: Array<TagsApproval>
	tagsID: string
	parentTagsID?: string
}
export type UpdateTags = TagsDetails & {
	tagsID: string
	requestorID: string
	action: 'UPDATE_TAGS'
	approvalStatus?: Array<TagsApproval>
}

export type Tags = TagsDetails & {
	tagsID: string
	requestorID: string
	creationTime: string
	lastUpdatedTime: string
	accountId?: string
	approvalStatus: Array<TagsApproval>
	parentTagsID?: string
}
export type ApproveTags = {
	action: 'UPDATE_APPROVE_STATUS'
	status: 'APPROVED'
	tagsID: string
}
export type UpdateApprovalTags = {
	action: 'UPDATE_APPROVER_STATUS'
	tagsID: string
	approvalStatus?: TagsApproval
}

export const getTagsApprovalObject = () => {
	const approvalStatus = CONSTANTS.APPROVER_TEAMS.map((item) => {
		return {
			name: item,
			status: null,
			approverID: '',
			lastUpdated: ''
		}
	})
	return approvalStatus
}

export const getEphemeralTagsApprovalObject = () => {
	const approvalStatus = CONSTANTS.PLATFORM_OWNER.map((item) => {
		return {
			name: item,
			status: null,
			approverID: '',
			lastUpdated: ''
		}
	})
	return approvalStatus
}
